import React, { useEffect, useState } from "react";
import IconCheckbox from "../../../ShareElements/IconCheckbox/IconCheckbox";
import Switch from "../../../ShareElements/TextInput/Switch";

const ACLMappingRowItem = (props) => {
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [Preselected, setPreSelected] = useState();
  const [IsChanged, setIsChanged] = useState(false);
  const [ACLOptions] = useState(props.ACLs);

  useEffect(() => {
    setPreSelected(props.Item);
  }, [props.Item]);

  const toggleDelete = () => {
    props.ShowDeleteAlert(props.Index, props.Item.id);
    setModalIsOpen(false);
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleACLChange = () => {
    if (!IsChanged) {
      setIsChanged(true);
    }

    props.EnableSave();

    setPreSelected(undefined);
  };

  return (
    <div className="form-row" key={props.Key}>
      <div className="xlarge select-holder">
        <select
          id={"Scope-" + props.Index + "-filter"}
          onChange={() => props.EnableSave()}
        >
          <option value={props.Item.scopeId}>
            {props.Item.preselectedScopeName}
          </option>
          {props.Scopes.map((Scope) => (
            <React.Fragment>
              {props.Item.preselectedScopeName === Scope.name ? null : (
                <option key={Scope.id} value={Scope.id}>
                  {Scope.name}
                </option>
              )}
            </React.Fragment>
          ))}
        </select>
        <i className="feather-chevron-down cx-select-icon"></i>
      </div>
      <div className="xlarge select-holder">
        <select
          id={"ACL-" + props.Index + "-filter"}
          onChange={() => handleACLChange()}
        >
          {Preselected && !IsChanged ? (
            <option selected value={Preselected.aclId}>
              {Preselected.preselectedACLName}
            </option>
          ) : null}
          {props.ACLs ? (
            <>
              {ACLOptions.map((ACL) => (
                <>
                  {Preselected && ACL.id === Preselected.aclId ? null : (
                    <option key={ACL.id} value={ACL.id}>
                      {ACL.name}
                    </option>
                  )}
                </>
              ))}
            </>
          ) : null}
        </select>
        <i className="feather-chevron-down cx-select-icon"></i>
      </div>
      <div className="large triple">
        {props.Item.view ? (
          <IconCheckbox
            Name={"View-" + props.Index}
            ActiveIcon={props.ViewActive}
            IsDefaultActive={true}
            DeactiveIcon={props.ViewDeactive}
            ChangeHandler={() =>
              props.HandleCheckboxChange("View-", props.Index)
            }
          />
        ) : (
          <IconCheckbox
            Name={"View-" + props.Index}
            ActiveIcon={props.ViewActive}
            IsDefaultActive={false}
            DeactiveIcon={props.ViewDeactive}
            ChangeHandler={() =>
              props.HandleCheckboxChange("View-", props.Index)
            }
          />
        )}
        {props.Item.edit ? (
          <IconCheckbox
            Name={"Edit-" + props.Index}
            ActiveIcon={props.EditActive}
            IsDefaultActive={true}
            DeactiveIcon={props.EditDeactive}
            ChangeHandler={() => props.HandleEdit(props.Index)}
          />
        ) : (
          <IconCheckbox
            Name={"Edit-" + props.Index}
            ActiveIcon={props.EditActive}
            IsDefaultActive={false}
            DeactiveIcon={props.EditDeactive}
            ChangeHandler={() => props.HandleEdit(props.Index)}
          />
        )}
        {props.Item.enabled ? (
          <Switch
            ChangeEvent={() =>
              props.HandleSwitchChange("status-" + props.Index)
            }
            Id={"status-" + props.Index}
            IsActive={true}
            ClassName="less-spaced"
          />
        ) : (
          <Switch
            ChangeEvent={() =>
              props.HandleSwitchChange("status-" + props.Index)
            }
            Id={"status-" + props.Index}
            IsActive={false}
            ClassName="less-spaced"
          />
        )}
      </div>
      <div className="large menu">
        <button
          onClick={() => props.DuplicateItem(props.Item, props.Index)}
          className="duplicate"
        >
          <i className="feather-copy"></i>
        </button>
        <button onClick={() => setModalIsOpen(true)} className="more"></button>
        <div className="more-info">
          <div
            className="modal-space"
            style={ModalIsOpen ? { display: "block" } : null}
            id={"modal-" + props.Index}
          >
            <div
              className="outline"
              onClick={() => setModalIsOpen(false)}
            ></div>
            <div className="modal-body double-item">
              <button className="btn" onClick={() => toggleDelete()}>
                <img alt="" src={props.DeleteIcon} />
                <div className="btn-text">
                  <p>{translateText("delete")}</p>
                  <p>{translateText("delete_this_record")}</p>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ACLMappingRowItem;
